export default __webpack_public_path__ + "static/media/person.aafdf423.svg";